import { HighlightMatch, } from 'flow-builder/hooks/useHighlight';
export const getIsNodeHighlighted = (id, nodes, isConnector) => {
    const { match, index } = nodes[id] || {};
    const isMatchConnectionInclusive = match === HighlightMatch.Connection || match === HighlightMatch.Both;
    const isMatchNodeInclusive = match === HighlightMatch.Node || match === HighlightMatch.Both;
    return (
    /*
     * If it's a connector and it's first in the array we don't want it highlighted.
     * This is because it's the connector leading up to the first node.
     */
    (isMatchConnectionInclusive && isConnector && index >= 1) ||
        (isMatchNodeInclusive && !isConnector && index >= 0));
};
